/**
 * Costruisce l'URL completo per le immagini caricate
 * Supporta:
 * - URL Cloudinary (già completi, iniziano con https://)
 * - Path relativi del backend (/uploads/...)
 * - Path locali del frontend (/images/...)
 */
export function getImageUrl(path: string | null | undefined): string {
  if (!path) {
    return 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&h=400&fit=crop'
  }

  // Se è già un URL completo (Cloudinary o altro), ritornalo
  if (path.startsWith('http')) {
    return path
  }

  // Se è un path relativo che inizia con /uploads, aggiungi il base URL del backend
  if (path.startsWith('/uploads')) {
    const backendUrl = import.meta.env.VITE_API_URL?.replace('/api', '') || 'http://localhost:3000'
    return `${backendUrl}${path}`
  }

  // Per altri path (es. /images/...) usa il frontend
  return path
}
